/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue'
import jQuery from 'jquery';

window.$ = window.jQuery = jQuery;
window.WOW = require('wowjs').WOW;
// window.Swiper = require('swiper').Swiper;


import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
import Multiselect from 'vue-multiselect'
// register globally
Vue.component('multiselect', Multiselect)

//import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';

// import { BFormDatepicker } from 'bootstrap-vue'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
// Vue.component('b-form-datepicker', BFormDatepicker)

import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
Vue.component('date-picker', datePicker)

jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
    icons: {
        time: 'fa-regular fa-clock',
        date: 'fa-solid fa-calendar-days',
        up: 'fa-solid fa-arrow-up',
        down: 'fa-solid fa-arrow-down',
        previous: 'fa-solid fa-chevron-left',
        next: 'fa-solid fa-chevron-right',
        today: 'fa-solid fa-calendar-check',
        clear: 'fa-regular fa-trash-alt',
        close: 'fa-regular fa-times-circle'
    }
});

//Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
//Vue.use(IconsPlugin)
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('calculator', require('./components/Calculator.vue').default);
//auth
Vue.component('register', require('./components/Auth/Register').default);
Vue.component('login', require('./components/Auth/Login').default);
Vue.component('forgotten', require('./components/Auth/Forgotten').default);
Vue.component('transactions', require('./components/Account/Transactions').default);
Vue.component('transaction-item', require('./components/Account/TransactionItem').default);
Vue.component('new-order', require('./components/Orders/NewOrder').default);
Vue.component('new-orders-list', require('./components/Orders/NewOrdersList').default);
Vue.component('new-orders-list-item', require('./components/Orders/NewOrderListItem').default);
Vue.component('comma-formatted-number', require('vue-comma-formatted-number'));
Vue.component('shops', require('./components/Shops/Shops').default)
Vue.component('shop-list', require('./components/Shops/ShopList').default)
Vue.component('shop-item', require('./components/Shops/ShopItem').default)
Vue.component('filter-shops', require('./components/FilterShops').default)
Vue.component('vue-pagination', require('laravel-vue-pagination'))
Vue.component('account-sidebar', require('./components/Account/Sidebar').default)
Vue.component('account-page', require('./components/Account/Account').default)
Vue.component('alert-modal', require('./components/Modals/AlertModal').default)
Vue.component('arrived-orders-page', require('./components/Orders/ArrivedOrdersPage').default)
//Vue.component('view-order', require('./components/Orders/ViewOrder').default)
Vue.component('view-order-container', require('./components/Orders/ViewOrderContainer').default)
Vue.component('new-to-on-warehouse-order', require('./components/Orders/View/NewToOnWarehouseOrder').default)
Vue.component('sent-to-delivered-order', require('./components/Orders/View/SentToDeliveredOrder').default)
Vue.component('arrived-order-page', require('./components/Orders/View/ArrivedOrderPage').default)
Vue.component('edit-order', require('./components/Orders/EditOrder').default);
Vue.component('file-upload', require('./components/Ui/FileUpload').default);
Vue.component('notification-alert-block', require('./components/Notifications/NotificationAlertBlock').default)
Vue.component('customs-comment', require('./components/Ui/CustomsComment').default)
Vue.component('register-ukraine', require('./components/Auth/Ukraine/Register').default);
Vue.component('register-step-two-ukraine', require('./components/Auth/Ukraine/RegisterStepTwo').default);
Vue.component('new-order-ukraine', require('./components/Orders/Ukraine/NewOrder').default);
Vue.component('edit-order-ukraine', require('./components/Orders/Ukraine/EditOrder').default);
Vue.component('ukraine-account-page', require('./components/Account/Ukraine/Account').default);
Vue.component('ukraine-stopped-order-page', require('./components/Orders/Ukraine/View/StoppedOrderPage').default)
Vue.component('ukraine-stopped-order', require('./components/Orders/Ukraine/View/StoppedOrder').default)
//Vue.component('input-autocomplete', VueTypeaheadBootstrap)
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#pesoto',
});
